<template>
    <popup v-model="show">
        <div class="popup-inner">
            <div class="modal-body">
                <img alt="" class="save-avatar-bg" src="../../assets/images/postalNewCustomer/save-avatar-bg.png">
                <img src="../../assets/images/postalNewCustomer/avatar.png" alt="" class="avatar-img">
                <div class="remark">快去青碳行中换上<br>你的限定头像炫耀一下吧~</div>
            </div>
            <img class="save-btn" src="../../assets/images/postalNewCustomer/save-img-btn.png" @click="handleSave">
        </div>
    </popup>
</template>

<script>
import { Popup } from 'vant'

export default {
    name: "SaveAvatarModal",
    components: { Popup },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        avatarNo: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            // avatarUrl: avatar
        }
    },
    computed: {
        show: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit('update:visible', val);
            }
        },
    },
    mounted() {
        window.saveSuccess = res => {
            if (res.result === '01') {
                this.$toast('保存成功');
                this.show = false
            }
        }
    },
    deactivated() {
        this.show = false
    },
    methods: {
        async handleSave() {
            const loading = this.$toast.loading({
                forbidClick: true,
                message: '正在努力下载...'
            })
            const imgBase64 = await require('./avatarBase64');
            if (this.$store.state.app.system === 'ios') {
                await window.webkit.messageHandlers.QTX_H5_SAVE_IMAGE_TO_ABLUM.postMessage({
                    base64: imgBase64.default,
                    callBack: 'saveSuccess',
                });
                loading.close()
            } else if (this.$store.state.app.system === 'android') {
                await window.CarbonWebView.savePicFile(imgBase64.default, `青碳行限定头像_${new Date().getTime()}.png`);
                loading.close()
            }
        },
        //查看使用规则
        checkRule() {
            this.$router.push({
                name: 'postalRules',
                query: { prizeId: 'b9b4ecc6-fa81-40fb-8b3a-767a1124c71c' }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./components/function";

.van-popup {
    background-color: transparent;
    width: 100%;
}
.popup-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.modal-coupon {
    width: 100%;
    position: relative;
    .coupon-bg {
        width: pxvw(492);
        height: auto;
    }
    .code-img {
        position: absolute;
        top: pxvw(178);
        left: 50%;
        margin-left: pxvw(-150);
        width: pxvw(300);
        height: pxvw(300);
        background: red;
    }
}
.button-img {
    width: auto;
    height: pxvw(80);
    margin-top: pxvw(26);
}
.remark {
    margin-top: pxvw(36);
    font-size: pxvw(26);
    color: #ffffff;
    text-align: center;
}
.rule-text {
    font-size: pxvw(20);
    margin-top: pxvw(14);
    color: #63e4fb;
    text-align: center;
    text-decoration: underline;
}

.modal-body {
    width: 100%;
    position: relative;
    .remark {
        text-align: center;
        color: white;
        font-size: pxvw(22);
        line-height: pxvw(40);
        position: absolute;
        bottom: pxvw(60);
        width: 100vw;
    }
    .save-avatar-bg {
        width: 100%;
        height: auto;
    }

    .avatar-img {
        position: absolute;
        width: pxvw(350);
        height: pxvw(350);
        z-index: 1000;
        height: auto;
        // border-radius: 50%;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        &.code-img {
            width: pxvw(375);
        }
    }

    .avatar-number {
        font-size: px2rem(24);
        color: #ffffff;
        position: absolute;
        bottom: 20%;
        left: 50%;
        transform: translateX(-50%);
        font-weight: 800;
    }
}

.save-btn {
    height: px2rem(94);
    width: auto;
    // margin: pxvw(-20) auto;
    margin-top: pxvw(-20);
    display: block;
}
</style>
